<ion-text>
  <figure>
    <blockquote
      [innerHTML]="node?.text"
      [ngClass]="['ion-text-' + node?.alignment]"
    ></blockquote>
    <figcaption [innerHTML]="'Author: ' + node?.caption"></figcaption>
  </figure>
</ion-text>
